<div #outsideModalCor class="modal" [ngClass]="{ 'loading': isLoading }">
    <div #modalBodyCor class="modal-content">
        <div class="modal-header">Édition d'un document</div>
        <div class="modal-body">

            <div class="action-tabs" *ngIf="isAuthor && formGroup">
                <ng-container *ngFor="let tab of editTabs">
                    <span (click)="selectTab(tab)" [ngClass]="{ 'selected': tab.id === currentTab.id }">{{ tab.label }}</span>
                </ng-container>
            </div>
            <form [formGroup]="formGroupVisibility" (ngSubmit)="onSubmitVisibility()" *ngIf="formGroupVisibility && document && document.uniqueId && document.uuid && !updateWithoutRight">
                <frg-form-input
                    id="visibility"
                    label="Visibilité"
                    type="ngSelect"
                    closeOnSelect="true"
                    [selectValue]="dmpParamVisibility"
                    [formGroup]="formGroupVisibility"
                    [control]="formGroupVisibility.get('visibility')"
                    [isClearableSelect]="false"
                ></frg-form-input>
                <div class="button-wrapper">
                    <frg-button *ngIf="!isAuthor" (activated)="closeModal()" [backgroundColor]="'var(--darkest-primary)'" [type]="'reset'">Annuler</frg-button>
                    <frg-button [type]="'submit'" [backgroundColor]="'var(--primary)'">Modifier la visibilité</frg-button>
                </div>
            </form>

            <form [formGroup]="formGroupArchive" (ngSubmit)="onSubmitArchive()" *ngIf="(isAuthor || isMt) && formGroupArchive && document && document.uniqueId && document.uuid && !updateWithoutRight">
                <frg-form-input
                    id="title"
                    label="Statut"
                    type="text"
                    [formGroup]="formGroupArchive"
                    [control]="formGroupArchive.get('archived')"
                    [disabled]="true"
                ></frg-form-input>
                <div class="button-wrapper">
                    <frg-button *ngIf="formGroupArchive && formGroupArchive.get('archived') && formGroupArchive.get('archived')?.value && dmpStatusEnumTemplate[formGroupArchive.get('archived')?.value] === dmpStatusEnumTemplate['Courant']" [type]="'submit'" [backgroundColor]="'var(--primary)'">Archiver</frg-button>
                    <frg-button *ngIf="formGroupArchive && formGroupArchive.get('archived') && formGroupArchive.get('archived')?.value && dmpStatusEnumTemplate[formGroupArchive.get('archived')?.value] === dmpStatusEnumTemplate['Document archivé']" [type]="'submit'" [backgroundColor]="'var(--primary)'">Désarchiver</frg-button>
                </div>
            </form>

            <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" *ngIf="isAuthor && formGroup">

                <ng-container *ngIf="currentTab.id === currentTabTpl.document">
                    <div class="new-doc-button-wrapper">
                        <frg-button (activated)="importDocument()" [backgroundColor]="'var(--primary)'">Modifier le document</frg-button>
                    </div>
    
                    <div class="text-infos-rights" *ngIf="updateWithoutRight">En raison de restrictions de droits d'accès au DMP de ce patient, il n'est pas possible de récupérer les informations liées à ce document pour les renseigner ici.<br>Il est néanmoins toujours possible de remplacer un document existant dont vous êtes l'auteur.</div>
    
                    <frg-form-input
                        id="title"
                        label="Titre"
                        type="text"
                        [formGroup]="formGroup"
                        [control]="formGroup.get('title')"
                    ></frg-form-input>
    
                    <frg-form-input
                        id="category"
                        label="Catégorie"
                        type="ngSelect"
                        closeOnSelect="false"
                        [selectValue]="dmpParamCategory"
                        [formGroup]="formGroup"
                        [control]="formGroup.get('category')"
                    ></frg-form-input>
    
                    <div class="radio-container">
                        <div class="radio-wrapper">
                            <input type="radio" id="documentFormat" name="documentFormatType" (change)="changeDocumentFormat('format')" [formControl]="formGroup.get('documentFormatType')" value="format">
                            <label class="radio-label" for="documentFormat">
                                <span class="label-wording">Format</span>
                            </label>
                        </div>
    
                        <div class="radio-wrapper">
                            <input type="radio" id="documentFormatCode" name="documentFormatType" (change)="changeDocumentFormat('formatCode')" [formControl]="formGroup.get('documentFormatType')" value="formatCode">
                            <label class="radio-label" for="documentFormatCode">
                                <span class="label-wording">Format code</span>
                            </label>
                        </div>
                    </div>
    
                    <ng-container *ngIf="formGroup.get('documentFormatType') && formGroup.get('documentFormatType').value === documentFormatTypeTemplate.format">
                        <frg-form-input
                            id="format"
                            label="Format"
                            type="ngSelect"
                            closeOnSelect="false"
                            [selectValue]="dmpParamFormat"
                            [formGroup]="formGroup"
                            [control]="formGroup.get('format')"
                        ></frg-form-input>
                    </ng-container>
    
                    <ng-container *ngIf="formGroup.get('documentFormatType') && formGroup.get('documentFormatType').value === documentFormatTypeTemplate.formatCode">
                        <frg-form-input
                            id="formatCode"
                            label="Format code"
                            type="ngSelect"
                            closeOnSelect="false"
                            [selectValue]="dmpParamFormatCode"
                            [formGroup]="formGroup"
                            [control]="formGroup.get('formatCode')"
                        ></frg-form-input>
                    </ng-container>
    
                    <frg-form-input
                        id="visibility"
                        label="Visibilité"
                        type="ngSelect"
                        closeOnSelect="false"
                        [selectValue]="dmpParamVisibility"
                        [formGroup]="formGroup"
                        [control]="formGroup.get('visibility')"
                    ></frg-form-input>
    
                    <frg-form-input
                        id="commentaire"
                        label="Commentaire"
                        type="textarea"
                        [formGroup]="formGroup"
                        [control]="formGroup.get('commentaire')"
                        [textareaResizable]="false"
                    ></frg-form-input>
        
                </ng-container>
    
                <ng-container *ngIf="currentTab.id === currentTabTpl.author">
                    <ng-container *ngTemplateOutlet="authorFormTpl;context:{ formGroup: authorForm, formWarn: authorFormWarn }"></ng-container>
                </ng-container>
    
                <ng-container *ngIf="currentTab.id === currentTabTpl.performer">
                    <ng-container *ngTemplateOutlet="authorFormTpl;context:{ formGroup: performerForm, formWarn: performerFormWarn }"></ng-container>
                </ng-container>
    
                <!-- <ng-container *ngIf="currentTab.id === currentTabTpl.authenticator">
                    <ng-container *ngTemplateOutlet="authorFormTpl;context:{ formGroup: authenticatorForm, formWarn: authenticatorFormWarn }"></ng-container>
                </ng-container> -->
    
                <div class="button-wrapper">
                    <frg-button (activated)="closeModal()" [backgroundColor]="'var(--darkest-primary)'" [type]="'reset'">Annuler</frg-button>
                    <frg-button [type]="'submit'" [backgroundColor]="'var(--primary)'" [disabled]="!formGroup.valid">Valider</frg-button>
                </div>

            </form>
        </div>
    </div>
</div>
<div class="modal-background"></div>

<ng-template #authorFormTpl let-form="formGroup" let-warnMsg="formWarn">

    <div class="form-warn-message">{{ warnMsg }}</div>

    <frg-form-input
        id="name"
        label="Nom"
        type="text"
        [formGroup]="form"
        [control]="form.get('name')"
    ></frg-form-input>

    <frg-form-input
        id="prenom"
        label="Prénom"
        type="text"
        [formGroup]="form"
        [control]="form.get('prenom')"
    ></frg-form-input>

    <frg-form-input
        id="profession"
        label="Profession"
        type="ngSelect"
        [selectValue]="professionSettings"
        [formGroup]="form"
        [control]="form.get('profession')"
    ></frg-form-input>

    <frg-form-input
        id="speciality"
        label="Spécialité"
        type="ngSelect"
        [selectValue]="specialiteSettings"
        [formGroup]="form"
        [control]="form.get('speciality')"
    ></frg-form-input>

    <frg-form-input
        id="idNat"
        label="Identitfiant National"
        type="text"
        [formGroup]="form"
        [control]="form.get('idNat')"
    ></frg-form-input>

    <frg-form-input
        id="idNatType"
        label="Type de l'Identifiant National"
        type="ngSelect"
        [selectValue]="internalIdTypes"
        [formGroup]="form"
        [control]="form.get('idNatType')"
    ></frg-form-input>

    <!--
        TODO: Sujet à suivre
        Les champs concernant la structure ne sont actuellement pas pris en compte par le connecteur DmpConnect.
        Dans tout les cas celui-ci va utiliser les informations de strcuture présentent sur la carte CPx.
        Ce sujet a été remonté à iCanopée et ils devraient ajouter cette possibilité prochainement.
    -->
    <!-- <frg-form-input
        id="practiceLocationBillingNumber"
        label="Identifiant de la structure"
        type="text"
        [formGroup]="form"
        [control]="form.get('practiceLocationBillingNumber')"
    ></frg-form-input>

    <frg-form-input
        id="practiceLocationName"
        label="Nom de la structure"
        type="text"
        [formGroup]="form"
        [control]="form.get('practiceLocationName')"
    ></frg-form-input>

    <frg-form-input
        id="practiceSettingValue"
        label="Cadre d'exercice de la structure"
        type="ngSelect"
        [selectValue]="dmpPracticeSettings"
        [formGroup]="form"
        [control]="form.get('practiceSettingValue')"
    ></frg-form-input> -->

</ng-template>